const buildFormData = (fields) => {
  console.log(fields);
  const fd = new FormData();
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null) fd.append(key, item);
      });
      return;
    }
    if (value instanceof File || value instanceof Blob) {
      fd.append(key, value);
      return;
    }
    fd.append(key, value);
  });
  return fd;
};

const buildJson = (fields) => {
  const out = {};
  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    out[key] = value;
  });
  return out;
};

const payloadHelper = {
  // Generic
  forBulk: (ids) => ({ ids }),
  forList: (params = {}) => buildJson(params),

  // Auth
  forLogin: ({ email, password }) => ({
    email: email.trim().toLowerCase(),
    password,
  }),
  forResetPassword: ({ email }) => ({
    email: email.trim().toLowerCase(),
  }),
  forFetchPermissions: (role_id) => ({ role_id }),
  forAssignPermissions: ({ role_id, permissions }) => ({ role_id, permissions }),
};

export default payloadHelper;
export { buildFormData, buildJson };
